import React, {Component} from 'react';
import './Radio.css';

export default class Radio extends Component {
	constructor(props) {
	    super(props);
	    this.state = {
            selectedoption: this.props.selectedoption
        };
        this.handleChange = this.handleChange.bind(this);
    }
    handleChange(event){

        let _option = event.target.getAttribute('id').toString();
        this.props.updateState(_option);
    }
    render() {
        let isChecked = () => {
            return this.props.label.toLowerCase() === this.props.selectedoption.toLowerCase()
        };
        return (<div className="custom-control custom-radio">
        <input onChange={this.handleChange} data-checked={isChecked()} type="checkbox" id={this.props.label.toLowerCase()} 
            name={this.props.name} className="custom-control-input" 
            checked={isChecked()}/>
        <label className="custom-control-label" data-checked={isChecked()} htmlFor={this.props.label.toLowerCase()}>{this.props.label}</label>
      </div>)
    }
}